// Recensioni verificate dei clienti
import React from 'react';
import { Star } from 'lucide-react';
import { ReviewsList } from '../../components/ReviewsList';
import { useShop } from '../ShopContext';
import { PageHeader, Section } from '../ShopUi';

export default function ShopReviews() {
  const { crafter, reviewStats } = useShop();
  return (
    <div data-testid="shop-reviews">
      <PageHeader title="Recensioni" subtitle="Solo recensioni di clienti che hanno acquistato su Rarifex." />
      <Section>
        {reviewStats.reviewCount > 0 && (
          <p className="mb-6 inline-flex items-center gap-2 text-lg">
            <Star className="w-6 h-6 fill-shop-accent text-shop-accent" />
            <span className="font-semibold">{reviewStats.averageRating.toFixed(1)}</span>
            <span className="text-slate-500">su 5 · {reviewStats.reviewCount} recensioni</span>
          </p>
        )}
        <ReviewsList crafterId={crafter.id} limit={30} />
      </Section>
    </div>
  );
}
